// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".titlequestion {\n  font-size: 18px;\n  color: #000206 !important;\n  font-weight: bold; }\n\n.secondtitle {\n  font-size: 16px;\n  color: #555555; }\n\n.decription {\n  font-size: 16px;\n  color: #555555; }\n\n.notes {\n  font-size: 14px;\n  color: #A5A5A5; }\n", ""]);
// Exports
module.exports = exports;
